<template>
  <div>
    <h1>Formation prégraduée</h1>
    <el-row style="width: 820px" v-loading="fpregradLoadStatus == 1">
      <el-col :span="24">
        <form-fpregrad :ismeddetail="ismeddetail" ref="formFpr">
        </form-fpregrad>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <div style="margin-top: 8px">
      <el-button @click="onBack">Retour</el-button>
      <el-button type="primary" @click="onSubmit">Enregistrer</el-button>
      <el-button @click="onCancel">Annuler</el-button>
    </div>
  </div>
</template>
<script>
import FormFpregrad from "@/components/rh/ui/form/FormFpregrad";
import { trimStringInObj } from "@/fonctions";

export default {
  components: { "form-fpregrad": FormFpregrad },

  data() {
    return {
      loadCount: 0,
    };
  },
  props: {
    ismeddetail: Boolean,
    routetolist: Object,
  },
  created() {
    this.$store.dispatch("fpr/loadFpregrad", this.idFpr);
  },
  mounted() {
    this.afficheData();
  },
  computed: {
    idFpr() {
      // récupère le id de la fpregrad dans l'url
      return String(this.$route.params.idfpr);
    },
    fpregradLoadStatus() {
      return this.$store.state.fpr.fpregradLoadStatus;
    },
    fpregradUpdateStatus() {
      // 1 = action en cours, 2 = succès, 3 = échec
      return this.$store.state.fpr.fpregradUpdateStatus;
    },
  },
  methods: {
    afficheData() {
      if (this.fpregradLoadStatus == 2) {
        // charge les données de la fpregrad
        const fpr = this.$store.state.fpr.fpregrad;
        // garde les données chargées dans le localStorage pour les comparée avec les modifs
        localStorage.fprLoaded = JSON.stringify(fpr);
      } else if (this.fpregradLoadStatus == 3) {
        // message échec
        this.$message.error({ message: "Echec du chargement des données !" });
      }
    },
    onSubmit() {
      this.$refs.formFpr.$refs.formFpregrad.validate((valid) => {
        if (valid) {
          let fprdata = this.$store.state.fpr.fpregrad;

          // enlever les espaces avant et après dans les string
          trimStringInObj(fprdata);

          const fprInDB = this.$store.getters["fpr/FpregradInBD"];
          const id = this.idFpr;
          const doublon =
            fprInDB.filter(
              (m) =>
                m[0] != id &&
                m[1] == fprdata.id_med &&
                m[2] == fprdata.id_fac &&
                (Number(m[3]) && Number(fprdata.annee)
                  ? m[3] == fprdata.annee
                  : false)
            ).length > 0;
          // prépare les données pour les comparer avec les données avant modification et pour l'enregistrement
          const fprdataStr = JSON.stringify(fprdata);

          // vérifie si les données ont été modifiées
          if (localStorage.fprLoaded == fprdataStr) {
            this.$message({
              message: "Les données n'ont pas été modifiées",
            });
            // vérifie si une fpregrad idendique existe déjà pour le médecin
          } else if (doublon) {
            this.$alert(
              "Ce médecin a déjà un titre enregistré pour la même année dans la même faculté",
              "Attention",
              {
                confirmButtonText: "Fermer",
                dangerouslyUseHTMLString: true,
              }
            );
            return false;
          } else {
            // si plus d'erreur
            //maj l'enregistrement
            this.$store.dispatch("fpr/updateFpregrad", fprdata);
          }
        } else {
          return false;
        }
      });
    },
    onCancel() {
      const fpr = this.$store.state.fpr.fpregrad;
      const fprStr = JSON.stringify(fpr);
      if (localStorage.fprLoaded != fprStr) {
        // si les données ont été modifiées
        let dataObj = JSON.parse(localStorage.fprLoaded);
        this.$store.commit("fpr/setFpregrad", dataObj);
        this.$message({
          message: "Les modifications ont été annulées",
          type: "warning",
        });
      } else {
        this.$message({
          message: "Les données n'ont pas été modifiées",
        });
      }
    },
    onBack() {
      // prépare les données pour les comparer avec les données avant modification
      const fpr = this.$store.state.fpr.fpregrad;
      const fprStr = JSON.stringify(fpr);

      if (localStorage.fprLoaded == fprStr) {
        // si pas de modifications
        // retourne à la liste des formations pré-graduées
        this.$router.push(this.routetolist);
      } else {
        this.$confirm(
          "Continuer sans enregistrer les modification ?",
          "Attention !",
          {
            confirmButtonText: "Continuer",
            cancelButtonText: "Annuler",
            type: "warning",
          }
        ).then(() => {
          // retourne à la liste des formations pré-graduées
          this.$router.push(this.routetolist);
        });
      }
    },
  },
  watch: {
    fpregradLoadStatus() {
      // ne lance l'affichage des données que si toutes les données sont chargées
      // lorsqu'on charge directement la page
      this.afficheData();
    },
    fpregradUpdateStatus() {
      // gère les messages et la navigation après soumission du formulaire
      if (this.fpregradUpdateStatus == 2) {
        // message succès
        this.$message({
          message: "Les modifications ont été enregistrées.",
          type: "success",
        });
        // place les données sauvegardée dans le localStorage (nouvelles données initiales)
        const fpr = this.$store.state.fpr.fpregrad;
        localStorage.fprLoaded = JSON.stringify(fpr);
      } else if (this.fpregradUpdateStatus == 3) {
        // message échec
        this.$message.error({ message: "Echec de l'enregistrement !" });
      }
    },
  },
};
</script>
